// HTML lang uses BCP 47 tags; route locales remain unchanged.
export const htmlLanguage = locale => ({
    'pt-br': 'pt-BR',
    'zh-cn': 'zh-CN',
    'zh-tw': 'zh-TW',
}[locale] || locale);
